import * as React from "react";
import { STRINGS } from "../strings";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { langMap, translate } from "../translate";
import { fmap } from "../utils/fmap";
import { withDefault } from "../utils/withDefault";
import { AppVersion } from "../version";
import CaregiverCard from "./CaregiverCard";
import { AppList, AppListDivider, AppListItem } from "./Generic/AppList";
import TrailingChevron from "./Generic/TrailingChevron/TrailingChevron";
import GenericSettingsScreen from "./GenericSettingsScreen";

interface SettingsScreenProps {
  caregiver: AppCaregiver;
  currentLanguage: string | undefined;
  onClickLanguage: () => void;
  onClickNotifications: () => void;
  onClickProfile: () => void;
  onClickSocial: () => void;
  onClickReferral: () => void;
  onClickGeneral: () => void;
  onClickAgencies: () => void;
  onClickBankInformation: () => void;
  onClickSignOut: () => void;
  onClickGoBack: () => void;
  onClickInformationCenter: (caregiver: AppCaregiver) => void;
}

const SettingsScreen = (props: SettingsScreenProps) => {
  const currentLanguage = withDefault(
    fmap(props.currentLanguage, (x) => langMap[x]),
    langMap["en"]
  );

  return (
    <GenericSettingsScreen
      title={translate(STRINGS.SETTINGS_AND_INFO)}
      onClickGoBack={props.onClickGoBack}
    >
      <CaregiverCard caregiver={props.caregiver} onClick={props.onClickProfile} />

      <AppListDivider />

      <AppList bordered={true}>
        <AppListItem
          title={translate(STRINGS.NOTIFICATIONS)}
          trailing={<TrailingChevron />}
          onClick={props.onClickNotifications}
        />
        <AppListItem
          title={translate(STRINGS.SOCIAL)}
          trailing={<TrailingChevron />}
          onClick={props.onClickSocial}
        />
        <AppListItem
          title={translate(STRINGS.REFERRAL_CODE)}
          trailing={<TrailingChevron />}
          onClick={props.onClickReferral}
        />
        <AppListItem
          title={translate(STRINGS.GENERAL)}
          trailing={<TrailingChevron />}
          onClick={props.onClickGeneral}
        />
        {props.caregiver.isInstapayAvailable && (
          <AppListItem
            title={translate(STRINGS.BANK_INFORMATION)}
            trailing={<TrailingChevron />}
            onClick={props.onClickBankInformation}
          />
        )}
        {!props.caregiver.shouldShowMyAgencies ? (
          <AppListItem
            title={translate(STRINGS.MY_AGENCIES)}
            trailing={<TrailingChevron />}
            onClick={props.onClickAgencies}
          />
        ) : null}
        <AppListItem
          title={translate(STRINGS.INFORMATION_CENTER)}
          onClick={() => props.onClickInformationCenter(props.caregiver)}
          trailing={<TrailingChevron />}
        />
        <AppListItem title={currentLanguage} onClick={props.onClickLanguage} />
        <AppListItem title={`${translate(STRINGS.MEDFLYT_VERSION)}: ${AppVersion}`} />
        <AppListItem
          title={<span data-text-color="danger">{translate(STRINGS.SIGN_OUT)}</span>}
          onClick={props.onClickSignOut}
        />
      </AppList>
    </GenericSettingsScreen>
  );
};

export default React.memo(SettingsScreen);
